"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _EntitySearch = _interopRequireDefault(require("./EntitySearch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Join extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleChange", (state, change) => {
      const {
        row,
        schema,
        onChange,
        dispatch
      } = this.props;
      if (onChange) {
        // BaseCreate no entity stored on server

        const value = state.map(data => {
          return {
            [schema.entities.foreign]: data,
            [`${schema.entities.local}Id`]: row.Id,
            [`${schema.entities.foreign}Id`]: data.Id
          };
        });
        onChange(value);
      } else {
        // BaseShow entity available serverside and changes stored immediately

        const {
          action,
          option,
          removedValue
        } = change;
        if (action === "select-option") {
          dispatch(schema.add({
            [`${schema.entities.local}Id`]: row.Id,
            [`${schema.entities.foreign}Id`]: option.Id
          }));
        }
        if (action === "remove-value") {
          const join = row[schema.entities.join].find(j => {
            return j[schema.entities.foreign] && j[schema.entities.foreign].Id === removedValue.Id;
          });
          console.log(join);
          dispatch(schema.drop(join.Id));
        }
      }
    });
  }
  render() {
    const {
      schema,
      value
    } = this.props;
    const selected = value ? value.map(v => v[schema.entities.foreign]) : null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EntitySearch.default, {
      isMulti: true,
      entity: schema.entities,
      onChange: this.handleChange,
      value: selected
    }));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(null, null)(Join);
module.exports = exports.default;